<script setup lang="ts">
import { computed } from 'vue'
import { Icon } from '@iconify/vue'
import { numHelper } from '@/utils/numHelper.ts'

interface Props {
  data: object | string | number
  cellConfig: Object,
}

const props = defineProps<Props>()

</script>

<template>
<div class="table-cell contract-commission-cell">
  <div class="seller_side">
    <strong><span>B</span> {{numHelper(props.data?.seller?.p * 100).format(2)}} <sup>%</sup></strong>
    <p v-if="props.data?.seller?.a">{{numHelper(props.data.seller.a).format(0, ',', '.')}} <sup>đ</sup></p>
    <p v-else>--</p>
  </div>
  <Divider layout="vertical"/>
  <div class="buyer_side">
    <strong><span>M</span> {{numHelper(props.data?.buyer?.p *100).format(2)}} <sup>%</sup></strong>
    <p v-if="props.data?.buyer?.a">{{numHelper(props.data.buyer.a).format(0, ',', '.')}} <sup>đ</sup></p>
    <p v-else>--</p>
  </div>
</div>
</template>

<style lang="scss">
.contract-commission-cell{

  display: flex;



  .seller_side{
    color: #b52200;
  }
  .buyer_side{
    color: #0070b5;
  }
  .seller_side,.buyer_side{
    word-break: keep-all;
    white-space: nowrap;
    strong{
      span{
        opacity: .3;
      }
    }
  }
}
</style>
